<template>
  <v-app>
    <v-parallax
      :src="require('@/assets/19.jpg')"
      height="100%"
      style="width: 100%; 
    height: 100%; 
    position: fixed; "
    >
      <v-container>
        <v-layout align-center justify-center row>
          <v-flex style="margin-right:30.5%;margin-left:30.5%;margin-top:10.5%;margin-bottom:2.5%;">
            <!-- xs7 sm8 md4 -->
            <v-card elevation="24">
              <v-toolbar clipped-left clipped-right color="orange">
                <v-toolbar-title>
                  <span style="color:white;">LPeC Portal</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-chip
                  :color="chipClr"
                  :outline="chpOutline"
                  @click="btm"
                  disabled
                  style="margin-left:7.5%;margin-top:2.5%"
                >
                  <v-window v-model="page">
                    <v-window-item :value="page">
                      <span :style="textClr">{{progress.text}}</span>
                    </v-window-item>
                  </v-window>
                  <v-spacer></v-spacer>
                  <v-switch
                    style="margin-top:15%;margin-left:7.5%"
                    color="iconClr"
                    v-model="progress.status"
                    @change="btm"
                  ></v-switch>
                </v-chip>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-show="!progress.status"
                    prepend-icon="person"
                    v-model="DisplayName"
                    label="Name "
                    type="text"
                    color="orange"
                    persistent-hint
                    hint="Ex: Trisnaldianto "
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="email"
                    persistent-hint
                    hint="Ex: hello@there.com"
                    v-model="ID"
                    label="Email"
                    type="text"
                    color="orange"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="lock"
                    v-model="Key"
                    label="Password"
                    type="password"
                    persistent-hint
                    hint="Min. 6 chars"
                    color="orange"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-layout justify-space-between>
                <v-card-actions style="margin-left:2.5%;margin-bottom:2.5%">
                  <v-icon dark @click="about" color="orange">info</v-icon>
                </v-card-actions>
                <v-card-actions style="margin-right:2.5%;margin-bottom:2.5%">
                  <v-btn color="orange" @click="submit" :loading="loading" :flat="loading">
                    <span style="color:white;">{{progress.status ? "Sign In" : "Sign Up"}}</span>
                  </v-btn>
                </v-card-actions>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-parallax>
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";
import axios from "axios";

const _auth = firebase.auth();

export default {
  data() {
    return {
      chpOutline: false,
      textClr: "color:orange;",
      chipClr: "white",
      page: 1,
      picker: new Date().toISOString().substring(0, 10),
      ID: "",
      DisplayName: "",
      Key: "",
      loading: false,
      progress: {
        status: false,
        text: "New Account"
      }
    };
  },
  methods: {
    about: function() {
      router.push("/about");
    },
    btm: function() {
      this.progress.status
        ? ((this.progress.status = !this.progress.status),
          (this.progress.text = "New Account"),
          (this.chipClr = "white"),
          (this.textClr = "color:orange;"),
          (this.chpOutline = false))
        : ((this.progress.status = !this.progress.status),
          (this.progress.text = "Existing User"),
          (this.chipClr = "white"),
          (this.textClr = "color:white;"),
          (this.chpOutline = true));
    },
    submit: function() {
      this.loading = true;
      if (this.ID && this.Key && this.DisplayName) {
        axios({
          method: "POST",
          url:
            "https://us-central1-asop-cc502.cloudfunctions.net/izzat/signPage",
          params: {
            name: this.DisplayName,
            key: this.Key,
            id: this.ID
          }
        })
          .then(() => {
            _auth.signInWithEmailAndPassword(this.ID, this.Key).catch(r => {
              alert(r);
              this.loading = false;
            });
          })
          .catch(rr => {
            alert(rr);
            this.loading = false;
            router.push("/portal");
          });
      } else if (this.ID && this.Key) {
        _auth
          .signInWithEmailAndPassword(this.ID, this.Key)
          .then(e => {
            _auth
              .updateCurrentUser(e.user)
              .then()
              .catch(rr => {
                alert(rr);
                router.replace("/");
              });
          })
          .catch(er => {
            alert(er);
            this.loading = false;
          });
      } else {
        alert("Wrong Form");
        this.loading = false;
      }
    }
  }
};
</script>
